import { render, staticRenderFns } from "./chevron-arrow-down.vue?vue&type=template&id=bd4e52da"
import script from "./chevron-arrow-down.vue?vue&type=script&lang=js"
export * from "./chevron-arrow-down.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports